<template>
  <v-dialog
    v-model="show"
    max-width="600"
    overlay-color="darktext"
    overlay-opacity="0.6"
    :persistent="loading ? true : false"
    disabled
  >
    <v-card class="pa-5">
      <v-card-title>
        {{ confirmationDialogTitle }}
      </v-card-title>
      <v-card-text>
        <v-form
          ref="form"
          v-model="valid"
          @keyup.enter="submitDialogBtn()"
          @submit.prevent
        >
          <p class="text-body-2 font-weight-bold mt-5">
            {{ $t('confirmationDialogTitleEditThread') }}
          </p>
          <v-text-field
            v-model="title"
            data-testid="thread-title"
            solo
            elevation="6"
            class="rounded-xxl text-body-2"
            :rules="titleRules"
            :placeholder="confirmationDialogInputPlaceholder"
          />
          <p class="text-body-2 font-weight-bold mt-5">
            {{ $t('confirmationDialogDescriptionEditThread') }}
          </p>
          <v-textarea
            v-model="description"
            data-testid="thread-description"
            elevation="6"
            class="rounded-xxl text-body-2"
            auto-grow
            solo
            :placeholder="confirmationDialogTextAreaPlaceholder"
          />
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          ref="cancel"
          data-testid="cancel-button"
          color="darktext"
          min-width="100"
          dark
          elevation="0"
          class="rounded-xxl text-none px-4 cancel"
          :disabled="loading"
          @click="show=false"
        >
          {{ confirmationDialogCancelBtn }}
        </v-btn>
        <v-btn
          ref="submit"
          data-testid="submit-button"
          type="submit"
          color="accent"
          min-width="100"
          dark
          elevation="0"
          class="rounded-xxl text-none px-4 submit"
          :loading="loading"
          @click="submitDialogBtn()"
        >
          {{ confirmationDialogSubmitBtn }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { ruleRequired, ruleValidMin2Max70Characters } from '../rules/formRules.js';
import i18n from '../plugins/i18n';

export default {
  props: {
    visible: Boolean,
    loading: {
      type: Boolean,
      default: false
    },
    item: {
      type: Object,
      default: () => {}
    }
  },
  data(){
      return{
        valid: true,
        titleRules: ruleRequired('labelTitle').concat(ruleValidMin2Max70Characters('labelTitle')),
        check: false,
        title: this.item.attributes.title,
        description: this.item.attributes.description,
        forumType:this.item.relationships['sharing-setting'].data.id,
        selectedItem:this.item.id,
        confirmationDialogTitle: i18n.t('confirmationDialogTitleForumThreadSettings'), 
        confirmationDialogInputPlaceholder: i18n.t('confirmationDialogInputPlaceholderActivityForumEditThread'),
        confirmationDialogTextAreaPlaceholder: i18n.t('confirmationDialogInputTextAreaPlaceholderActivityForumEditThread'), 
        confirmationDialogSubmitBtn: i18n.t('save'),
        confirmationDialogCancelBtn: i18n.t('cancel'),
      }
    },  
    computed: {
        show: {
            get () {
                return this.visible
            },
            set (value) {
                if (!value) {
                    this.$emit('close')
                    this.$refs.form.reset()
                }
            }
        },
        
    },
    methods: {
      submitDialogBtn() {
        this.valid = this.$refs.form.validate()
        if(this.valid){
          this.$emit('proceedSubmit',this.title, this.description,this.forumType,this.selectedItem)
        }
      },
  },
}
</script>
